import React from 'react';
import { formatValueWithoutCurrency } from '../../../../helpers/currency.helper';

interface IncomeExpensesLinearChartProps {
  label: string;
  amount: string;
  percentage: number;
  fillColour?: string;
}

interface TotalItem {
  title: string;
  total: number;
}

// Internal usage within IncomeExpenses component
const IncomeExpensesLinearChart = ({
  label, amount, percentage, fillColour,
}: IncomeExpensesLinearChartProps) => (
  <div className='flex my-5'>
    <div className='flex-col grow-0 mr-5 ext-[14px] text-bw07 min-w-[70px]'>
      <p className='font-metricR text-sm' data-testid='IncomeExpensesLinearChart__label'>
        {label}
      </p>
      <p className='font-metricR text-sm'>
        $
        <span className='font-metricRSemibold' data-testid='IncomeExpensesLinearChart__amount'>{amount}</span>
      </p>
    </div>
    <div className='grow self-end pb-[5px]'>
      <div className='h-[8px] bg-bw03 rounded-[48px] relative'>
        <div
          className={`h-full rounded-[48px] z-20 ${fillColour}`}
          style={{ width: `${percentage === 0 ? 0 : percentage > 5 ? percentage : 5}%`, maxWidth: '100%' }}
          data-testid='IncomeExpensesLinearChart__bar'
        />
      </div>
    </div>
  </div>
);

export interface IncomeExpensesProps {
  income: TotalItem;
  expense: TotalItem;
}

export const IncomeExpenses = ({ income, expense }: IncomeExpensesProps) => {
  const total = income && Object.keys(income).length > 0 && expense && Object.keys(expense).length > 0 ? income.total + expense.total : 0;
  const incomePercentage = total > 0 ? (income.total / total) * 100 : 0;
  const expensePercentage = total > 0 ? (expense.total / total) * 100 : 0;
  return (
    <div className='pb-[20px]' data-testid='IncomeExpensesGraph__wrapper'>
      <IncomeExpensesLinearChart
        label={income?.title}
        amount={formatValueWithoutCurrency(income?.total || 0, 2)}
        percentage={incomePercentage}
        fillColour='bg-action02'
      />
      <IncomeExpensesLinearChart
        label={expense?.title}
        amount={formatValueWithoutCurrency(expense?.total || 0, 2)}
        percentage={expensePercentage}
        fillColour='bg-action03'
      />
    </div>

  );
};
